export default __webpack_public_path__ + "static/media/back-arrow.2da80233.svg";